var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocEventDetail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0161 10.8991C15.0161 11.5518 14.8176 12.1898 14.4459 12.7325C14.0742 13.2752 13.5458 13.6982 12.9277 13.9479C12.3095 14.1977 11.6293 14.263 10.973 14.1357C10.3168 14.0084 9.71399 13.6941 9.24087 13.2326C8.76774 12.7711 8.44554 12.1831 8.31501 11.5429C8.18447 10.9028 8.25147 10.2393 8.50752 9.63627C8.76357 9.03327 9.19718 8.51788 9.75352 8.15527C10.3099 7.79266 10.9639 7.59912 11.633 7.59912C12.0773 7.59912 12.5172 7.68448 12.9277 7.85032C13.3381 8.01616 13.711 8.25924 14.0252 8.56567C14.3393 8.8721 14.5885 9.23589 14.7585 9.63627C14.9286 10.0366 15.0161 10.4658 15.0161 10.8991Z",
    stroke: "#292C31",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.9C22 18.6 11.5 25.2 11.5 25.2C11.5 25.2 1 18.6 1 10.9C1 8.27436 2.10625 5.75625 4.07538 3.89964C6.04451 2.04303 8.71523 1 11.5 1C14.2848 1 16.9555 2.04303 18.9246 3.89964C20.8938 5.75625 22 8.27436 22 10.9Z",
    stroke: "#292C31",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocEventDetail);
export default __webpack_public_path__ + "static/media/locEventDetail.43c698e31a873de803d0f1130ecd3f7c.svg";
export { ForwardRef as ReactComponent };